<template>
  <div class="form-field" :class="{ required }">

    <ValidationProvider :name="name" :value="value" v-slot="{ errors }" persist :rules="rules">

      <div class="form-group">

        <div class="">

          <input class="form-check-input"
                 :class="{'validation-error': errors.length > 0 }"
                 type="checkbox"
                 :name="name"
                 :id="name"
                 v-model="checked"
                 @input.stop
                 @change.stop
          >
          <label class="form-check-label d-flex align-items-center"
                 :for="name"
                 :class="{
                               'validation-error': errors.length > 0,
                               'selected': value
                           }"
          >
            <div style="height: 30px; width: 30px; display:flex; justify-content: center; align-items: center">
              <div v-if="!value" style="width: 20px; height: 20px; border-radius: 150px; border: 2px solid currentColor"></div>
              <svg v-if="value" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.707-1.293a1 1 0 0 0-1.414-1.414L11 12.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4-4Z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <p class="ml-2 p-1 mb-0" style="line-height: 1em; font-weight: normal">{{ label }}</p>
          </label>

        </div>

        <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

      </div>

    </ValidationProvider>
  </div>
</template>

<script>
import {ValidationProvider} from "vee-validate"

export default {
  name: "CheckBox",
  props: ["name", "value", "label", "rules", "required"],
  components: {
    ValidationProvider
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.required {

  .form-check-label:after {
    content: '*';
    color: red;
  }
}

input {
  visibility: visible !important;
  opacity: 0 !important;
  height: 0;
  width: 0;
}

input:focus, input:focus + label {
  border-radius: 0.25em;
  border: 3px solid lightblue;
}

label.form-check-label {
  font-weight: 400;
  display: block;
  width: 100%;
  min-height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #2e3031;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;

  &.selected {
    border: 2px solid #2e3031;
    font-weight: bold;
  }

  &:hover {
    cursor: pointer;
  }
}
</style>
